<!-- Coming Soon Section -->
<section class="coming-soon-section d-flex align-items-center justify-content-center" style="min-height: calc(100vh - 200px);">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8 text-center">
        <div class="coming-soon-content">
          <i class="fa fa-calendar-days text-primary mb-5" style="font-size: 5rem;"></i>
          <h1 class="display-3 fw-bold mb-4" style="color: #181c32;">Shows & Events</h1>
          <h2 class="h3 fw-semibold mb-4" style="color: #009ef7;">Coming Soon</h2>
          <p class="lead text-muted mb-5" style="font-size: 1.25rem; line-height: 1.8;">
            We're working hard to bring you an exciting lineup of barrel racing events and competitions.
            Check back soon for upcoming shows, registration details, and more!
          </p>
          <div class="d-flex justify-content-center">
            <a routerLink="/" class="btn btn-primary btn-lg px-5 py-3">
              <i class="fa fa-home me-2"></i>Back to Home
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--
<div class="container-xxl py-10">
  Page Header
  <div class="d-flex flex-wrap flex-stack mb-10">
    <h1 class="fw-bold my-2">Upcoming Shows & Events</h1>
  </div>

  Filters Section
  <div class="card mb-10">
    <div class="card-body">
      <div class="row g-5">
        Search Filter
        <div class="col-md-4">
          <label class="form-label fw-semibold">Search Events</label>
          <app-input-component
            [type]="'text'"
            [(value)]="searchQuery"
            [placeholder]="'Search by name, description, or city...'"
            (valueChange)="onSearchChange()"
          />
        </div>

        Event Type Filter
        <div class="col-md-3">
          <label class="form-label fw-semibold">Event Type</label>
          <app-selectorini
            [options]="eventTypes"
            [displayKey]="'event_type_name'"
            [valueKey]="'event_type_id'"
            [(value)]="selectedEventTypeId"
            [placeholder]="'All Types'"
            (valueChange)="onEventTypeChange()"
          />
        </div>

        Company Filter
        <div class="col-md-3">
          <label class="form-label fw-semibold">Organizer</label>
          <app-selectorini
            [options]="companies"
            [displayKey]="'company_name'"
            [valueKey]="'company_id'"
            [(value)]="selectedCompanyId"
            [placeholder]="'All Organizers'"
            (valueChange)="onCompanyChange()"
          />
        </div>

        Clear Filters Button
        <div class="col-md-2 d-flex align-items-end">
          <app-button
            [variant]="'neutral'"
            [label]="'Clear Filters'"
            [iconClass]="'fa fa-times'"
            (clicked)="clearFilters()"
            class="w-100"
          />
        </div>
      </div>
    </div>
  </div>

  Loading State
  @if (loading) {
    <div class="text-center py-20">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="text-muted mt-5">Loading events...</p>
    </div>
  }

  No Results
  @if (!loading && filteredEvents.length === 0) {
    <div class="card">
      <div class="card-body text-center py-20">
        <i class="fa fa-calendar-xmark fs-3x text-muted mb-5"></i>
        <h3 class="text-muted">No events found</h3>
        <p class="text-muted">Try adjusting your filters or check back later for new events.</p>
      </div>
    </div>
  }

  Upcoming Events
  @if (!loading && upcomingEvents.length > 0) {
    <div class="mb-10">
      <h2 class="fw-bold mb-6">
        <i class="fa fa-calendar-check text-success me-3"></i>Upcoming Events
      </h2>
      <div class="row g-6 g-xl-9">
        @for (event of upcomingEvents; track event.event_id) {
          <div class="col-md-6 col-lg-4">
            <div class="card h-100 event-card">
            Event Image
            <div class="event-image-container position-relative">
              @if (event.header_url) {
                <img [src]="event.header_url" class="card-img-top event-image" [alt]="event.event_name"/>
              } @else {
                <div class="event-image-placeholder bg-light d-flex align-items-center justify-content-center">
                  <i class="fa fa-calendar fs-3x text-muted"></i>
                </div>
              }

              Event Status Badge
              <div class="position-absolute top-0 end-0 m-3">
                @if (isEventUpcoming(event.start_date)) {
                  <span class="badge badge-success badge-lg">Upcoming</span>
                } @else if (isEventPast(event.start_date)) {
                  <span class="badge badge-secondary badge-lg">Past</span>
                }
              </div>
            </div>

            <div class="card-body d-flex flex-column">
              Event Type Badge
              <div class="mb-3">
                <span class="badge" [ngClass]="getEventTypeBadgeClass(event.event_type_id)">{{ getEventTypeDisplay(event.event_type_id) }}</span>
              </div>

              Event Name
              <h3 class="card-title fw-bold fs-4 mb-3">{{ event.event_name }}</h3>

              Event Details
              <div class="mb-5 mt-auto">
                <div class="row g-3">
                  Left Column
                  <div class="col-6">
                    Dates
                    @if (event.start_date) {
                      <div class="d-flex align-items-start mb-3">
                        <i class="fa fa-calendar text-primary me-2 fs-6 mt-1"></i>
                        <div>
                          <div class="fw-semibold fs-7">{{ formatDateDMYDots(event.start_date) }}</div>
                          @if (event.end_date && event.start_date !== event.end_date) {
                            <div class="text-muted fs-8">to {{ formatDateDMYDots(event.end_date) }}</div>
                          }
                        </div>
                      </div>
                    }

                    Location
                    <div class="d-flex align-items-start mb-3">
                      <i class="fa fa-location-dot text-primary me-2 fs-6 mt-1"></i>
                      <div>
                        <div class="fw-semibold fs-7">{{ event.city }}, {{ event.country }}</div>
                        @if (event.address) {
                          <a [href]="getGoogleMapsUrl(event)" target="_blank" class="text-muted fs-8 address-link text-decoration-none">
                            {{ event.address }}
                            <i class="fa fa-external-link ms-1 fs-9"></i>
                          </a>
                        }
                      </div>
                    </div>

                    Registration Deadline
                    @if (event.registration_deadline) {
                      <div class="d-flex align-items-start">
                        <i class="fa fa-clock text-warning me-2 fs-6 mt-1"></i>
                        <div>
                          <div class="text-muted fs-8">Reg. Deadline</div>
                          <div class="fw-semibold fs-7">{{ formatDateDMYDots(event.registration_deadline) }}</div>
                        </div>
                      </div>
                    }
                  </div>

                  Right Column
                  <div class="col-6">
                    Available Classes
                    <div class="d-flex align-items-start mb-3 hover-info-container" (mouseenter)="loadEventClasses(event.event_id)">
                      <i class="fa fa-list text-info me-2 fs-6 mt-1"></i>
                      <div class="flex-grow-1">
                        <div class="fw-semibold fs-7">Classes</div>
                        <div class="text-muted fs-8">Hover to view</div>
                      </div>
                      <div class="hover-popup">
                        <div class="hover-popup-content">
                          <div class="hover-popup-header">
                            <i class="fa fa-list me-2"></i>Available Classes
                          </div>
                          <div class="hover-popup-body">
                            @if (loadingClasses[event.event_id]) {
                              <div class="text-center py-2">
                                <div class="spinner-border spinner-border-sm text-primary" role="status">
                                  <span class="visually-hidden">Loading...</span>
                                </div>
                              </div>
                            } @else if (eventClasses[event.event_id] && eventClasses[event.event_id].length > 0) {
                              <ul>
                                @for (eventClass of eventClasses[event.event_id]; track eventClass.event_class_id) {
                                  <li>
                                    <i class="fa fa-circle-check"></i>
                                    <strong>{{ eventClass.class_name }}</strong>
                                    @if (eventClass.price) {
                                      <span class="text-muted ms-2">({{ eventClass.price }} {{ eventClass.price_currency || 'kr' }})</span>
                                    }
                                  </li>
                                }
                              </ul>
                            } @else {
                              <div class="text-muted text-center py-2">No classes available</div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    Available Services
                    <div class="d-flex align-items-start hover-info-container" (mouseenter)="loadEventServices(event.event_id)">
                      <i class="fa fa-concierge-bell text-success me-2 fs-6 mt-1"></i>
                      <div class="flex-grow-1">
                        <div class="fw-semibold fs-7">Services</div>
                        <div class="text-muted fs-8">Hover to view</div>
                      </div>
                      <div class="hover-popup">
                        <div class="hover-popup-content">
                          <div class="hover-popup-header">
                            <i class="fa fa-concierge-bell me-2"></i>Available Services
                          </div>
                          <div class="hover-popup-body">
                            @if (loadingServices[event.event_id]) {
                              <div class="text-center py-2">
                                <div class="spinner-border spinner-border-sm text-primary" role="status">
                                  <span class="visually-hidden">Loading...</span>
                                </div>
                              </div>
                            } @else if (eventServices[event.event_id] && eventServices[event.event_id].length > 0) {
                              <ul>
                                @for (service of eventServices[event.event_id]; track service.event_service_id) {
                                  <li>
                                    <i class="fa fa-circle-check"></i>
                                    <strong>{{ service.event_service_name }}</strong>
                                    @if (service.price) {
                                      <span class="text-muted ms-2">({{ service.price }} {{ service.price_currency || 'kr' }})</span>
                                    }
                                  </li>
                                }
                              </ul>
                            } @else {
                              <div class="text-muted text-center py-2">No services available</div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              Action Button
              <div class="mt-auto text-center">
                <app-button
                  [variant]="'primary'"
                  [label]="'View Details'"
                  [routerLink]="'/event-details/' + event.event_id"
                />
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  }

  Divider
  @if (!loading && upcomingEvents.length > 0 && pastEvents.length > 0) {
    <div class="separator-section my-10">
      <div class="d-flex align-items-center">
        <div class="flex-grow-1 border-bottom border-gray-300"></div>
        <div class="px-5">
          <span class="badge badge-light-secondary badge-lg">Past Events</span>
        </div>
        <div class="flex-grow-1 border-bottom border-gray-300"></div>
      </div>
    </div>
  }

  Past Events
  @if (!loading && pastEvents.length > 0) {
    <div class="mb-10">
      @if (upcomingEvents.length === 0) {
        <h2 class="fw-bold mb-6">
          <i class="fa fa-calendar-xmark text-secondary me-3"></i>Past Events
        </h2>
      }
      <div class="row g-6 g-xl-9">
        @for (event of pastEvents; track event.event_id) {
          <div class="col-md-6 col-lg-4">
            <div class="card h-100 event-card">
            Event Image
            <div class="event-image-container position-relative">
              @if (event.header_url) {
                <img [src]="event.header_url" class="card-img-top event-image" [alt]="event.event_name"/>
              } @else {
                <div class="event-image-placeholder bg-light d-flex align-items-center justify-content-center">
                  <i class="fa fa-calendar fs-3x text-muted"></i>
                </div>
              }

              Event Status Badge
              <div class="position-absolute top-0 end-0 m-3">
                @if (isEventUpcoming(event.start_date)) {
                  <span class="badge badge-success badge-lg">Upcoming</span>
                } @else if (isEventPast(event.start_date)) {
                  <span class="badge badge-secondary badge-lg">Past</span>
                }
              </div>
            </div>

            <div class="card-body d-flex flex-column">
              Event Type Badge
              <div class="mb-3">
                <span class="badge" [ngClass]="getEventTypeBadgeClass(event.event_type_id)">{{ getEventTypeDisplay(event.event_type_id) }}</span>
              </div>

              Event Name
              <h3 class="card-title fw-bold fs-4 mb-3">{{ event.event_name }}</h3>

              Event Details
              <div class="mb-5 mt-auto">
                <div class="row g-3">
                  Left Column
                  <div class="col-6">
                    Dates
                    @if (event.start_date) {
                      <div class="d-flex align-items-start mb-3">
                        <i class="fa fa-calendar text-primary me-2 fs-6 mt-1"></i>
                        <div>
                          <div class="fw-semibold fs-7">{{ formatDateDMYDots(event.start_date) }}</div>
                          @if (event.end_date && event.start_date !== event.end_date) {
                            <div class="text-muted fs-8">to {{ formatDateDMYDots(event.end_date) }}</div>
                          }
                        </div>
                      </div>
                    }

                    Location
                    <div class="d-flex align-items-start mb-3">
                      <i class="fa fa-location-dot text-primary me-2 fs-6 mt-1"></i>
                      <div>
                        <div class="fw-semibold fs-7">{{ event.city }}, {{ event.country }}</div>
                        @if (event.address) {
                          <a [href]="getGoogleMapsUrl(event)" target="_blank" class="text-muted fs-8 address-link text-decoration-none">
                            {{ event.address }}
                            <i class="fa fa-external-link ms-1 fs-9"></i>
                          </a>
                        }
                      </div>
                    </div>

                    Registration Deadline
                    @if (event.registration_deadline) {
                      <div class="d-flex align-items-start">
                        <i class="fa fa-clock text-warning me-2 fs-6 mt-1"></i>
                        <div>
                          <div class="text-muted fs-8">Reg. Deadline</div>
                          <div class="fw-semibold fs-7">{{ formatDateDMYDots(event.registration_deadline) }}</div>
                        </div>
                      </div>
                    }
                  </div>

                  Right Column
                  <div class="col-6">
                    Available Classes
                    <div class="d-flex align-items-start mb-3 hover-info-container" (mouseenter)="loadEventClasses(event.event_id)">
                      <i class="fa fa-list text-info me-2 fs-6 mt-1"></i>
                      <div class="flex-grow-1">
                        <div class="fw-semibold fs-7">Classes</div>
                        <div class="text-muted fs-8">Hover to view</div>
                      </div>
                      <div class="hover-popup">
                        <div class="hover-popup-content">
                          <div class="hover-popup-header">
                            <i class="fa fa-list me-2"></i>Available Classes
                          </div>
                          <div class="hover-popup-body">
                            @if (loadingClasses[event.event_id]) {
                              <div class="text-center py-2">
                                <div class="spinner-border spinner-border-sm text-primary" role="status">
                                  <span class="visually-hidden">Loading...</span>
                                </div>
                              </div>
                            } @else if (eventClasses[event.event_id] && eventClasses[event.event_id].length > 0) {
                              <ul>
                                @for (eventClass of eventClasses[event.event_id]; track eventClass.event_class_id) {
                                  <li>
                                    <i class="fa fa-circle-check"></i>
                                    <strong>{{ eventClass.class_name }}</strong>
                                    @if (eventClass.price) {
                                      <span class="text-muted ms-2">({{ eventClass.price }} {{ eventClass.price_currency || 'kr' }})</span>
                                    }
                                  </li>
                                }
                              </ul>
                            } @else {
                              <div class="text-muted text-center py-2">No classes available</div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    Available Services
                    <div class="d-flex align-items-start hover-info-container" (mouseenter)="loadEventServices(event.event_id)">
                      <i class="fa fa-concierge-bell text-success me-2 fs-6 mt-1"></i>
                      <div class="flex-grow-1">
                        <div class="fw-semibold fs-7">Services</div>
                        <div class="text-muted fs-8">Hover to view</div>
                      </div>
                      <div class="hover-popup">
                        <div class="hover-popup-content">
                          <div class="hover-popup-header">
                            <i class="fa fa-concierge-bell me-2"></i>Available Services
                          </div>
                          <div class="hover-popup-body">
                            @if (loadingServices[event.event_id]) {
                              <div class="text-center py-2">
                                <div class="spinner-border spinner-border-sm text-primary" role="status">
                                  <span class="visually-hidden">Loading...</span>
                                </div>
                              </div>
                            } @else if (eventServices[event.event_id] && eventServices[event.event_id].length > 0) {
                              <ul>
                                @for (service of eventServices[event.event_id]; track service.event_service_id) {
                                  <li>
                                    <i class="fa fa-circle-check"></i>
                                    <strong>{{ service.event_service_name }}</strong>
                                    @if (service.price) {
                                      <span class="text-muted ms-2">({{ service.price }} {{ service.price_currency || 'kr' }})</span>
                                    }
                                  </li>
                                }
                              </ul>
                            } @else {
                              <div class="text-muted text-center py-2">No services available</div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              Action Button
              <div class="mt-auto text-center">
                <app-button
                  [variant]="'primary'"
                  [label]="'View Details'"
                  [routerLink]="'/event-details/' + event.event_id"
                />
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  }
</div>
-->
